import type { Account } from '@api/hooks/useAccounts';
import { AccountList } from '@components/AccountList';
import type { PaginatedAccountsResult } from '@hooks/usePaginatedAccounts';
import { forwardRef, useEffect } from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface ReceiverAccountRenderProps {
	field: Omit<ControllerRenderProps, 'ref'>;
	accounts: Account[];
	disabledAccounts?: (string | number)[];
	pagination: PaginatedAccountsResult;
	isLoading: boolean;
	hideBalance?: boolean;
}

export const ReceiverAccountRender = forwardRef<
	HTMLDivElement,
	ReceiverAccountRenderProps
>(
	(
		{
			field,
			accounts,
			pagination,
			disabledAccounts,
			isLoading,
			hideBalance,
		}: ReceiverAccountRenderProps,
		ref,
	) => {
		const { t } = useTranslation();

		useEffect(() => {
			if (!field.value && accounts.length > 0) {
				field.onChange(accounts[1]);
			}
		}, [field.value, field.onChange, accounts]);

		return (
			<div ref={ref} className="mt-space-40">
				{field.value && (
					<AccountList
						disabledAccounts={disabledAccounts}
						hideBalance={hideBalance}
						isLoading={isLoading}
						label={t('payments.common.to')}
						options={accounts}
						pagination={pagination}
						{...field}
					/>
				)}
			</div>
		);
	},
);

ReceiverAccountRender.displayName = 'ReceiverAccountRender';
